import { SALES_ORDER_DETAIL_PAGE } from "routes/route.constant";
import DetailSalesOrder from "./DetailSalesOrder";

const route = {
  path: SALES_ORDER_DETAIL_PAGE,
  element: DetailSalesOrder,
};

export default route;
